import { CookieNames } from '@/constants/Cookies';
import { getCookie } from '~/lib/cookie-helpers';

export default ({ app }) => {};
